
import request from "@/utils/request";
import config from "@/config";
// let serveUrl = config.baseUrl;
// let serveUrl = 'http://192.168.2.71:20001/';
// let personalCenterBaseUrl = config.personalCenterBaseUrl;

// let adminCenterUrl = config.adminCenterUrl;

// 获取用户列表
// export function getUserList(data) {
//   return request({
//     url: `${serveUrl}portalCenter/api/rest/center/userData/getUserList?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&key=${data.key}`,
//     method: "get",
// 		headerType: "portal"
//   });
// }

// 获取用户安全手机
// export function findSecurityPhone(data){
// 	return request({
// 		url: `${serveUrl}portalCenter/api/rest/center/userData/findSecurityPhone?userId=${data.userId}`,
// 		method: "get",
// 		headerType: "portal"
// 	})
// }

// 更新用户安全手机
// export function updateSecurithPhone(data){
// 	return request({
// 		url: `${serveUrl}portalCenter/api/rest/center/userData/updateSecurityPhone?phoneNumber=${data.phoneNumber}&userId=${data.userId}`,
// 		method: "get",
// 		headerType: "portal"
// 	})
// }

export function previewDocInBrower(data){
	return request({
		url: `${config.portalCenterUrl}api/rest/center/oa/previewDocInBrower?docid=${data.docid}`,
		method: "get",
		headerType: "portal",
		// responseType: "arraybuffer"
		responseType: "blob",
	})
}